
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getOrderTaskList, taskSendReceive, taskFinish } from '@/api/orderTask';
import { UserModule } from '@/store/modules/user';
import { OrderTaskStage } from '@/types/orderTask';
import { IPagination } from '@/types';
import eventBus from '@/utils/eventBus';

import buttonList from '@/components/TaskButtonList/index.vue';
import BbsDialog from '@/components/BbsDialog/index.vue';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
// import DrawerDetail from '@/components/Drawer/DrawerDetail.vue';

import { checkPermissionUseAndCompany, getModelPermission } from '@/utils/permission';
import { ModuleType, Type, ViewType } from '@/types/permissionType';

@Component({
  name: 'TaskList',
  components: {
    dialogImgLarge,
    buttonList,
    BbsDialog,
    // DrawerDetail
  }
})
export default class extends Vue {
  // 东改
  @Prop({
    default: OrderTaskStage.Task_STAGE_ALL,
    validator: (value) => OrderTaskStage !== undefined
  })
  private stage!: OrderTaskStage;

  // 批量寄回
  private dialogGroupOrderBackVisible = false
  private formGroupOrderBack: any = {
    result: '',
    company: '',
    number: '',
    brief: ''
  }

  // 页码处理
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList()
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList()
  }

  // 基本请求参数
  private isSend=false;

  private fixSummary:any={};
  created() {
    // this.getList();
    // 当搜索组件出发这个事件后，刷新列表
    eventBus.$on('orderTaskSearch', this.handleSearchCondition);
    this.isSend = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.TASK_SEND);
  }

  beforeDestroy() {
    // 在离开页面的时候注销掉该eventBus的事件，否则会在多个页面中重复请求
    eventBus.$off('orderTaskSearch', this.handleSearchCondition);
  }

  // 各种搜索条件参数
  private searchParams: any = {}
  // 此处进行了 进一步处理  随后总结   解决 切换页码时 搜索参数没有包含 造成数据有误
  handleSearchCondition(searchParams?: any) {
    // 每次搜索 或 清空时  页码都要置位1
    this.pagination.currentPage = 1;
    this.searchParams = searchParams;
    this.getList();
  }

  private handleCheckAllChange(val: boolean) {
    let orderOptions: any = [];

    if (val) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (parseInt(this.dataList[i].order_task.deal_type) === 3) {
          orderOptions.push(this.dataList[i]);
        }
      }
    } else {
      orderOptions = [];
    }
    this.taskSelected = orderOptions;
    this.isIndeterminate = false;
  }
  private taskSelected:any = [];
  private taskSelectedAll = false;
  private isIndeterminate: any = null;
  private handleCheckedTaskChange(val:any) {
    let checkedCount = val.length;
    let _length = this.dataList.length;
    this.taskSelectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
  // 批量收货
  private handleTackGoods() {
    let taskId = '';
    if (!(this.taskSelected && this.taskSelected.length > 0)) {
      this.showErrorMsg('请选择需要收货的任务');
      return;
    }
    this.taskSelected.forEach((element:any) => {
      taskId = taskId + element.order_task.id + ',';
    });
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      order_task_id: taskId
    };
    taskSendReceive(params).then(res => {
      this.showSuccessMsg('收货成功');
      this.getList();
    }).catch((err) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 批量寄回
  private handleSendBack() {
    if (!(this.taskSelected && this.taskSelected.length > 0)) {
      this.showErrorMsg('请选择需要收货的任务');
      return;
    }
    this.fixSummary = getModelPermission(ViewType.DEAL_TASK, this.taskSelected[0].order.order_type, 0, this.taskSelected[0].order_task.company_id, ModuleType.ORDER_FIX_SUMMARY);
    this.dialogGroupOrderBackVisible = true;
  }
  private finishTask() {
    if (!this.formGroupOrderBack.company) {
      this.showErrorMsg('请输入物流公司');
      return;
    }
    if (!this.formGroupOrderBack.number) {
      this.showErrorMsg('请输入物流单号');
      return;
    }
    if (!this.formGroupOrderBack.brief && this.fixSummary.m === 1) {
      this.showErrorMsg('请填写维修小结');
      return;
    }
    let taskId = '';
    this.taskSelected.forEach((element:any) => {
      taskId = taskId + element.order_task.id + ',';
    });
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      order_task_id: taskId,
      reply_type: this.formGroupOrderBack.result,
      reply_express_number: this.formGroupOrderBack.number,
      reply_express_name: this.formGroupOrderBack.company,
      fix_summary: this.formGroupOrderBack.brief
    };
    taskFinish(params).then(res => {
      this.showSuccessMsg('收货成功');
      this.getList();
    }).catch((err) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 获取任务列表数据
  private dataList:any = [];
  private listLoading = false

  getList(searchParams?: any) {
    this.dataList = []
    this.listLoading = true;
    const params = {
      stage: this.stage,
      platform_type: 'user',
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.searchParams
    };
    getOrderTaskList(params).then(res => {
      const data = res.data;
      if (data) {
        this.pagination.total = data.count ? parseInt(data.count) : 0;
        // this.pagination.pageSize = parseInt(data.page_size);
        this.pagination.currentPage = parseInt(data.page_current);
        this.dataList = data.list;
        // for (const item of data['list']) {
        //   let state = bottomBtnTaskState(parseInt(item.order_task.state));
        // }
      } else {
        this.dataList = [];
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      this.dataList = [];
      let msg = err.msg;
    });
  }

  // 任务详情处理 查看详情时 需要先发送请求 获取具体信息  OrderTask/order
  private showDrawerDetails = false;
  private DetailsDataQuery: any = {};
  private closeDrawerDetail(val:boolean) {
    this.showDrawerDetails = val
  }
  private clickTaskDetail(val: any, index: any) {
    let routeData = this.$router.resolve({
      path: '/Task/todetail',
      // 'taskDetail': data,
      query: {
        'taskId': val.order_task.id,
        'companyId': val.order_task.company_id,
        'orderType': val.order.order_type,
        'enterType': '1',
        'isDetail': '1',
        'isProgress': index,

      },
    });
    window.open(routeData.href);
    // this.showDrawerDetails = true;
    // this.DetailsDataQuery = {
    //   'taskId': val.order_task.id,
    //   'companyId': val.order_task.company_id,
    //   'orderType': val.order.order_type,
    //   'enterType': '1',
    //   'isDetail': '1',
    //   'isProgress': index,
    // }
  }

  // 显示处理
  getTagsHtml(r:any) {
    let kind = ''; let kindType = ''; let abnormal = "";
    let plain = 'plain';
    if (parseInt(r.order.order_type) === 1) {
      kind = '其他';
      kindType = 'warning';
    } else if (parseInt(r.order.order_type) === 2) {
      kind = '维保';
      kindType = 'success';
    } else if (parseInt(r.order.order_type) === 3) {
      kind = '安装';
      kindType = 'danger';
    } else if (parseInt(r.order.order_type) === 4) {
      kind = '巡检';
      kindType = '';
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = '维保';
      kindType = 'success';
    }

    let deal = '';
    switch (parseInt(r.order_task.deal_type)) {
      case 1:
        deal = '远程';
        break;
      case 2:
        deal = '上门';
        break;
      case 3:
        deal = '寄送';
        break;
      case 4:
        deal = '转派';
        break;
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部";
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = ''; let darkplain = 'dark';
    if (parseInt(r.order_service.charge) === 1) {
      charge = '收费';
    }

    let expedited = '';
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = '加急';
    }

    // 2019-05-23 迭代 订单排位
    let ranking = '';
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + '号';
      }
    }

    let check = '';
    if (parseInt(r.order.check_state) === 11 || parseInt(r.order.check_state) === 51) {
      check = '审核';
    }

    let pause = '';
    if (parseInt(r.order_task.pause_last_state) === 1) {
      pause = '暂停';
    }

    let enquiry = '';
    if (parseInt(r.order_service.is_assign_enquiry) === 1) {
      enquiry = '询价';
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    let urgent = ''
    if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
      urgent = '已催单' + r.order.reminder.count + '次'
    }
    let refuse = "";
    if (
      parseInt(r.order.refuse_accept_complete_count) > 0
    ) {
      refuse = "拒验";
    }
    return [{
      type: "",
      label: source,
      plain: darkplain,
    }, {
      type: 'warning', label: check, plain: darkplain
    }, {
      type: kindType, label: kind, plain: plain
    }, {
      type: '', label: deal, plain: darkplain
    }, {
      type: "danger",
      label: abnormal,
      plain: darkplain,
    }, {
      type: 'danger', label: charge, plain: darkplain
    }, {
      type: 'danger', label: expedited, plain: darkplain
    }, {
      type: 'danger', label: ranking, plain: darkplain
    }, {
      type: "warning",
      label: urgent,
      plain: plain,
    }, {
      type: 'danger', label: pause, plain: darkplain
    },{
      type: 'danger', label: enquiry, plain: darkplain
    },
    {
      type: "danger",
      label: refuse,
      plain: darkplain,
    },
  ];
  }

  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  // 不根据state判断，所以永远置为1
  private state: number = 1;
  private mesgHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
  }
  private closeBbs(value: boolean) {
    this.getList();
    this.bbsDialogVisible = value;
  }

  // hud loading
  // private arraySpanMethod(IOrderColspan:any) {
  //   if (IOrderColspan.columnIndex === 0) {
  //     return [1, 9];
  //   } else {
  //     return [0, 0];
  //   }
  // }

  // arraySpanMethodExpand(IOrderColspan:any) {
  //   if (IOrderColspan.columnIndex === 9 - 2) {
  //     return [1, 2];
  //   } else if (IOrderColspan.columnIndex === 9 - 1) {
  //     return [0, 0];
  //   }
  // }

  // 点击放大图片 播放视频
  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
